import { IconSvg } from '../../types'

export const NightIcon: IconSvg = (props) => {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" {...props}>
      <path
        d="M13.1053 10.0498C12.4719 10.3044 11.7801 10.4445 11.0556 10.4445C8.01799 10.4445 5.55556 7.98205 5.55556 4.94448C5.55556 4.21996 5.69565 3.52817 5.95022 2.8947C3.92785 3.70743 2.5 5.68699 2.5 8.00004C2.5 11.0376 4.96243 13.5 8 13.5C10.3131 13.5 12.2926 12.0722 13.1053 10.0498Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
